<template>
  <div v-if="showQuetions" :key="componentKey" class="ml-4">
    <div class="d-flex flex-column">
      <div class="question-element">
        <div class="item-pane">
          <div class="question-box">
            <div class="box-number">
              <div>
                {{ model.numberLabel | removePoint }}
                <sup class="question-number-sup" />
              </div>
            </div>
          </div>
          <div class="question-line col py-3">
            <p class="mb-0 p-2 pl-4">
              {{ model.text }}
            </p>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <RadioButton
              :question-lists="{
                name: 'rbQuestion' + model.id,
                invalid: false,
                options: model.answers.map((a) => ({
                  id: a.id,
                  label: a.text,
                  check: model.selected === a.id,
                  disabled: isReadOnly || model.disabled,
                })),
              }"
              :change-event="onChange"
              class="radio-button-container"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="showAgency">
      <div v-for="agency in model.agencies" :key="model.id + '-' + agency.id">
        <QuestionCheckbox
          :key="agency.id"
          :model="agency"
          :readonly="isReadOnly"
          @selectedCheck="onClickChild"
        />
      </div>
    </div>
    <div
      v-if="model.isOpenAnswer && model.selected === yesOrNotEnum.no"
      :key="'comment' + model.id"
    >
      <div class="col-md-12 comment-section">
        <ValidationProvider
          v-slot="{ errors }"
          slim
          name="razones"
          rules="required"
        >
          <CustomTextArea
            :id="'openAnswer'"
            v-model="model.openAnswer"
            style="width:100%"
            :maxlength="500"
            :classes="['eq-field', 'text-left']"
            :rows="5"
            :disabled="readonly"
            :error="errors[0]"
            required
            :label="model.openAnswerTitle"
            placeholder="Explique razones..."
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>
<script>
import QuestionCheckbox from './QuestionCheckbox';
import RadioButton from '@/components/common/CustomRadioButton';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ValidationProvider } from 'vee-validate';
import yesOrNotEnum from '@/utils/constants/yesOrNotEnum';

export default {
  props: {
    section: {
      type: Object,
      default: () => {},
    },
    model: {
      type: Object,
      default: function() {
        return { disabled: false };
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    QuestionCheckbox,
    RadioButton,
    CustomTextArea,
    ValidationProvider,
  },
  data() {
    return {
      componentKey: 0,
      isReadOnly: this.readonly,
      // JSF: I'm declaring this data because I have seen they are using it (this.isValid)
      // without having it declared...
      isValid: null,
    };
  },
  filters: {
    removePoint(value) {
      if (value.includes('.')) {
        return value.slice(0, value.length - 1);
      }
      return value;
    },
  },

  computed: {
    showAgency: function() {
      if (this.section !== undefined) {
        let question7b = this.section.questions.find((x) => x.id === 11);
        let responseQuestion7b = question7b.selected === this.yesOrNotEnum.yes;
        return responseQuestion7b;
      }
      return false;
    },
    showQuetions: function() {
      if (this.getNumberQuetion === '') {
        return false;
      } else if (
        this.getNumberQuetion === '' ||
        (this.section !== undefined && this.getNumberQuetion === '7')
      ) {
        let question7 = this.section.questions.find((x) => x.id === 8);
        let responseQuestion7 = question7.selected === this.yesOrNotEnum.yes;
        return responseQuestion7;
      }
      return true;
    },
    getNumberQuetion: function() {
      let number = this.model.numberLabel.split('(')[0];
      return number;
    },
    getclassQuetion: function() {
      let classname = 'Q' + this.getNumberQuetion + 'Answer';
      return classname;
    },
    yesOrNotEnum() {
      return yesOrNotEnum;
    },
  },
  methods: {
    onClickButton() {
      this.componentKey += 1;
      this.$emit('selected', this.model);
    },
    validate() {
      this.$emit('selected', this.model, this.isValid);
    },
    onClickChild() {
      this.validate();
    },
    onChange(item) {
      this.model.selected = item.id;
      this.onClickButton();
    },
  },
  watch: {
    readonly: function() {
      this.isReadOnly = this.readonly;
    },
  },
};
</script>

<style scoped>
.infoleft {
  text-align: left;
}

.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-number {
  font: Bold 32px/19px Lato;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}
.comment-section {
  background: #f4f6f3;
  margin-left: 64px;
  width: 86%;
  padding: 27px 10px 10px 32px;
}
</style>
